import React, { useContext, useEffect } from "react";
import "./MenuPage.scss";
import { useNavigate } from "react-router";
import { useOrder } from "../../Context/useOrder";
import { observer } from "mobx-react";
import { dataContext } from "../../Context/contextProvider";
import { useAuth } from "../../Context/useAuth";

interface Props {}

const MenuPage = observer((props: Props) => {
  const navigate = useNavigate();
  const { setCurrentOrder } = useOrder();
  const dataStore = useContext(dataContext);
  const { isAllowed } = useAuth();

  useEffect(() => {
    setCurrentOrder(null);
  }, [setCurrentOrder]);

  const onNavigate = (routeName: string) => {
    if (routeName) {
      navigate(routeName);
    }
  };

  return (
    <div className="container-limited-width menu-page">
      <div className="row">
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_pick") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/orders")}>
              <i className="fa fa-barcode fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Pick</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_pack") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/packlist")}>
              <i className="fa fa-archive fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Pack</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_putaway") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/putaway")}>
              <i className="fa fa-hourglass fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Put Away</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_stockcount") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/stockcount")}>
              <i className="fa fa-list-ol fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Stock Count</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_stockcheck") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/stockcheck")}>
              <i className="fa fa-search fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Stock Check</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_move") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/move")}>
              <i className="fa fa-arrows fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">BIN Move</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_return") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/returnstock")}>
              <i className="fa fa-stack-exchange fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Return To Stock</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_dispatch") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/dispatch")}>
              <i className="fa fa-paper-plane-o fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Dispatch</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_prepick") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/prepick")}>
              <i className="fa fa-list-alt fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Pre Pick</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_order") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/salesordercustomer")}>
              <i className="fa fa-shopping-cart fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Order</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_quote") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/quotecustomer")}>
              <i className="fa fa-file-text-o fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Quote</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_stockrequest") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/stockrequests")}>
              <i className="fa fa-exchange fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">Stock Requests</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_3pltallyin") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/tallyin")}>
              <i className="fa fa-truck fa-5x" aria-hidden="true"></i>
              <div className="title flex-row">3PL Tally In</div>
            </div>
          </div>
        )}
        {isAllowed(dataStore.serverUrl!, dataStore.dbKey!, "allow_3pltallyout") && (
          <div className="col-6">
            <div className="box-part text-center d-flex flex-column justify-content-around" onClick={() => onNavigate("/tallyout")}>
              <i className="fa fa-truck fa-5x fa-flip-horizontal" aria-hidden="true"></i>
              <div className="title flex-row">3PL Tally Out</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default MenuPage;
